module.exports = __webpack_public_path__ + "dashboard/img/left.a3a7197a4e91c234547bf94d9f076ce4.svg";